import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconBell, IconBellOff } from '@tabler/icons-react';

import {
  useDisableIsHotDialogNotification,
  useEnableIsHotDialogNotification,
} from '../../../../api';
import { Platform } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

type Props = {
  isHotDialogNotificationEnabled?: boolean;
  pageId: string;
  platform: Platform;
};

export const NotificationButton = ({ pageId, isHotDialogNotificationEnabled, platform }: Props) => {
  const enableHotDialogNotification = useEnableIsHotDialogNotification();
  const disableHotDialogNotification = useDisableIsHotDialogNotification();

  if (isHotDialogNotificationEnabled) {
    return (
      <Tooltip label="Disable Hot Dialogs Notification">
        <ActionIcon
          loading={disableHotDialogNotification.isLoading}
          color="teal"
          radius="md"
          onClick={() =>
            NiceModal.show(ConfirmModal, {
              title: 'Disable Hot Dialogs Notification?',
              onSuccess: () => disableHotDialogNotification.mutate({ pageId, platform }),
            })
          }
        >
          <IconBell />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip label="Enable Hot Dialogs Notification">
      <ActionIcon
        loading={enableHotDialogNotification.isLoading}
        radius="md"
        onClick={() =>
          NiceModal.show(ConfirmModal, {
            title: 'Enable Hot Dialogs Notification?',
            onSuccess: () => enableHotDialogNotification.mutate({ pageId, platform }),
          })
        }
      >
        <IconBellOff />
      </ActionIcon>
    </Tooltip>
  );
};
